import { LinearProgress, Skeleton, Stack } from '@mui/material';

function GenericLoader() {
  return (
    <Stack spacing={2} p={2}>
      <LinearProgress sx={{ borderRadius: 1 }} />
      <Skeleton 
        variant="rectangular" 
        height={48} 
        sx={{ borderRadius: 1 }} 
        animation="wave"
      />
      <Skeleton 
        variant="rectangular" 
        height={80} 
        sx={{ borderRadius: 1 }} 
        animation="wave"
      />
      <Skeleton 
        variant="rectangular" 
        height={64} 
        sx={{ borderRadius: 1 }} 
        animation="wave"
      />
    </Stack>
  );
}

export default GenericLoader;
